import { GetColorByName } from 'functions/GetColorByName';
import React from 'react';

export interface CustomAvatarProps {
  avatarName: string;
  imgWidth?: number;
  imgHeight?: number;
}

const CustomAvatar: React.FC<CustomAvatarProps> = ({
  avatarName,
  imgWidth = 120,
  imgHeight = 60,
}) => {
  // Split name into parts, remove "AS", allow max 3 lines
  const parts = avatarName
    .split(/\s+/)
    .filter((part) => part.toUpperCase() !== 'AS')
    .slice(0, 3);

  const lineCount = parts.length;

  // HØYDE-beregning av font
  const lineHeightPx = imgHeight / lineCount;
  const byHeight = lineHeightPx * 0.6;

  // BREDDDE-beregning av font — vi tar den lengste linjen
  const longest = parts.reduce((a, b) => (a.length > b.length ? a : b), '');
  const byWidth = imgWidth / (longest.length * 0.6);

  // Velg den minste av de to beregningene
  const fontSizePx = Math.max(Math.floor(Math.min(byHeight, byWidth)), 10);

  const { background, text } = GetColorByName(avatarName);

  return (
    <div
      style={{
        width: imgWidth,
        height: imgHeight,
        borderRadius: 10,
        border: '1px solid rgba(0,0,0,0.2)',
        background,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        userSelect: 'none',
      }}
    >
      {parts.map((part, index) => (
        <span
          key={index}
          style={{
            fontSize: fontSizePx,
            lineHeight: `${lineHeightPx}px`,
            color: text,
            margin: 0,
            width: '100%',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {part}
        </span>
      ))}
    </div>
  );
};

export default CustomAvatar;
